/* PP · Einzelprodukt – Teil Auswahl: Größen-Knöpfe als Raster (bis 3 Spalten, höchstens 2 Zeilen, sonst „+ x weitere“) und Farb-/Design-Bilder in
   EINER Reihe (Rest hinter „+ x“; liegt die gewählte Ausführung bzw. das gewählte Design im versteckten Teil, bleibt alles offen).
   Wo benutzt: sections/pp-einzel lädt die Datei auf jeder Produktseite (vor dem Kern)      Abschaltbar: mit dem Abschnitt
   Liest: Knöpfe [data-pp-e-knoepfe] (snippets/pp-einzel-groessen) / .pp-e__swatches (snippets/pp-einzel-designs)
   Braucht: Kern pp-einzel-kaufbox.js   Ohne Daten: ohne Knöpfe/Bilder tut der Teil nichts
   Schnittstelle: hinterlegt wurzel.__ppTeile.auswahl – liefert raster() an den Kern (nach jeder Wahl). Fehlt die Datei: alle Knöpfe/Bilder sichtbar, kein „+ x“.
   Katalog: shop/baukasten/bausteine.md · Stand: 2026-10-07 (C4 Schritt 5: aus assets/pp-einzel.js, Code der Abschnitte unverändert) */
(function () {
  'use strict';
  var wurzel = document.querySelector('[data-pp-e]');
  if (!wurzel) return;
  // Einrichtung nur hinterlegen – der Kern (pp-einzel-kaufbox.js, lädt danach) ruft sie an der alten Stelle auf und reicht die Helfer (E)
  (wurzel.__ppTeile = wurzel.__ppTeile || {}).auswahl = function (E) {
    var q = E.q, qa = E.qa, text = E.text;
    // --- 2 · Größen/Ausführungen: Raster bis 3 Spalten, höchstens 2 Zeilen, sonst „+ x weitere“ ---
    var reihe = q('[data-pp-e-knoepfe]'), mehr = q('[data-pp-e-mehr]'), offen = false;
    function raster() {
      if (!reihe || !mehr) return;
      var ks = qa('[data-pp-e-var]', reihe), spalten = Math.min(3, ks.length), platz = spalten * 2, zuViele = ks.length > platz;
      var ai = -1; ks.forEach(function (k, i) { if (k.classList.contains('pp-aktiv')) ai = i; });
      if (zuViele && ai >= platz - 1) offen = true; // gewählte Ausführung liegt im versteckten Teil → aufgeklappt zeigen
      ks.forEach(function (k, i) { k.classList.toggle('pp-zu', zuViele && !offen && i >= platz - 1); });
      mehr.hidden = !zuViele;
      if (zuViele) { text(mehr, offen ? '− weniger' : '+ ' + (ks.length - platz + 1) + ' weitere'); mehr.setAttribute('aria-expanded', offen ? 'true' : 'false'); }
    }
    if (mehr) mehr.addEventListener('click', function () { offen = !offen; raster(); });

    // --- 3 · Farb-/Design-Bilder: nur EINE Reihe (Handy und PC), der Rest hinter „+ x“ (liegt das gewählte Design dort, bleibt alles offen) ---
    var swReihe = q('.pp-e__swatches'), swMehr = q('[data-pp-e-swmehr]'), swOffen = false;
    function swRaster() {
      if (!swReihe || !swMehr) return;
      var sws = qa('.pp-e__sw', swReihe).filter(function (s) { return s !== swMehr; });
      sws.forEach(function (s) { s.classList.remove('pp-zu'); });
      swMehr.hidden = true;
      // 25.09.2026 (Nutzer nach Umbau D: „nur eine zeile und den rest zum ausklappen, es ist sowieso schon überladen“): Handy UND PC eine Reihe,
      // der Rest hinter „+ x“ (vorher: am Handy Wisch-Reihe, in D kurz alles offen)
      if (!sws.length) return;
      var oben = sws[0].offsetTop, erste = sws.filter(function (s) { return s.offsetTop <= oben + 2; }).length;
      if (erste >= sws.length) return; // alles passt in eine Reihe
      swMehr.hidden = false;
      if (swOffen) { text(swMehr, '−'); swMehr.setAttribute('aria-expanded', 'true'); swMehr.setAttribute('aria-label', 'Weniger Designs zeigen'); return; }
      var platz = erste - 1, ai = -1; // ein Platz für den Knopf „+ x“
      sws.forEach(function (s, i) { if (s.classList.contains('pp-aktiv')) ai = i; });
      if (ai >= platz) { swMehr.hidden = true; return; } // gewähltes Design liegt hinten: alles offen, ohne wirkungslosen „−“-Knopf
      sws.forEach(function (s, i) { if (i >= platz) s.classList.add('pp-zu'); });
      text(swMehr, '+' + (sws.length - platz)); swMehr.setAttribute('aria-expanded', 'false'); swMehr.setAttribute('aria-label', (sws.length - platz) + ' weitere Designs zeigen');
    }
    if (swMehr) swMehr.addEventListener('click', function () { swOffen = !swOffen; swRaster(); });
    window.addEventListener('resize', swRaster);
    swRaster();
    return { raster: raster };
  };
})();
